import { AfterViewInit, Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
	selector: '[appAutoFocus]',
})
export class AutoFocusDirective implements OnInit, AfterViewInit {
	public constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

	public ngOnInit(): void {
		this.elementRef.nativeElement.focus();
	}

	public ngAfterViewInit(): void {}
}
